import Vue from 'vue'
import Vuex from 'vuex'
import app from './app'
import lawStore from './lawStore'
import common from './common'
Vue.use(Vuex)

const state = {}
const mutations = {}
const getters = {}
const actions = {}
export default new Vuex.Store({
  state,
  mutations,
  actions,
  getters,
  modules: {
    app,
    lawStore,
    common
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js